import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PrepTourAnchorDirective } from './tour-anchor.directive';
import { PrepTourCoachmarkComponent } from './tour-coachmark.component';
import { PrepTourDialogComponent } from './tour-dialog.component';
import { PrepTourOutletComponent } from './tour-outlet.component';
import { PrepTourProgressComponent } from './tour-progress.component';
import { PrepTourSpotlightComponent } from './tour-spotlight.component';

/**
 * In-product guidance engine. Import where the outlet is hosted (layout,
 * remediation page) and wherever a template registers `[prepTourAnchor]`.
 */
@NgModule({
  imports: [CommonModule, MatButtonModule, MatIconModule, A11yModule],
  declarations: [
    PrepTourOutletComponent,
    PrepTourSpotlightComponent,
    PrepTourCoachmarkComponent,
    PrepTourDialogComponent,
    PrepTourProgressComponent,
    PrepTourAnchorDirective,
  ],
  exports: [PrepTourOutletComponent, PrepTourAnchorDirective],
})
export class PrepTourModule {}
